import { render, staticRenderFns } from "./AddLinkBtn.vue?vue&type=template&id=0460b917&scoped=true&"
import script from "./AddLinkBtn.vue?vue&type=script&lang=js&"
export * from "./AddLinkBtn.vue?vue&type=script&lang=js&"
import style0 from "./AddLinkBtn.vue?vue&type=style&index=0&id=0460b917&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0460b917",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/datavol/sites/sphir-ui-master/releases/20210903105233/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0460b917')) {
      api.createRecord('0460b917', component.options)
    } else {
      api.reload('0460b917', component.options)
    }
    module.hot.accept("./AddLinkBtn.vue?vue&type=template&id=0460b917&scoped=true&", function () {
      api.rerender('0460b917', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/app/components/PostForm/AddLinkBtn.vue"
export default component.exports